"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputConsumer = _interopRequireDefault(require("../InputConsumer"));

var _IconAffixSt = require("./IconAffix.st.css");

var IconAffix = function IconAffix(_ref) {
  var children = _ref.children,
      dataHook = _ref.dataHook;
  return /*#__PURE__*/_react["default"].createElement(_InputConsumer["default"], {
    consumerCompName: IconAffix.displayName
  }, function (_ref2) {
    var size = _ref2.size,
        inPrefix = _ref2.inPrefix,
        inSuffix = _ref2.inSuffix,
        border = _ref2.border,
        disabled = _ref2.disabled,
        onInputClicked = _ref2.onInputClicked;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _IconAffixSt.st)(_IconAffixSt.classes.root, {
        size: size,
        inPrefix: inPrefix,
        inSuffix: inSuffix,
        border: border,
        disabled: disabled
      }),
      onClick: !disabled ? onInputClicked : undefined,
      "data-hook": dataHook
    }, /*#__PURE__*/_react["default"].cloneElement(children, {
      size: size === 'small' ? '18px' : '24px'
    }));
  });
};

IconAffix.displayName = 'Input.IconAffix';
IconAffix.propTypes = {
  children: _propTypes["default"].element.isRequired,
  dataHook: _propTypes["default"].string
};
var _default = IconAffix;
exports["default"] = _default;